import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  loggMeIN,
  rmAuth,
  toggleMenu,
} from "../../redux/Functions/actions";
import {
  MenuButton,
  PageStyle,
  PageTitleStyle,
  TableResponsive,
  TableBody,
  TableHead,
  TableRowHead,
  TableRowBody,
  PageContainer,
  Table,
  TableHeadStyle,
  Pagination,

  TableBodyStyle,
  EyeIcon
} from "../../styles/MainLayout";
import CitiesModal from "./citiesModal";
import ReactPaginate from "react-paginate";

import Search from "../search/search";
import axios from "../../axios"

const Cities = (props) => {

  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [userData, setUserData] = useState();
  // const [usercountries, setUserCountries] = useState();
  const [CityID, setCityID] = useState();
  const [countryNames, setCountryNames] = useState();


  const [filtered, setFiltered] = useState([]);

  //Pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 8;
  const pagesVisited = pageNumber * productsPerPage;
  const pageCount = Math.ceil(filtered.length / productsPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  }

  const getUserData = () => {
    axios.get('/cities/all').then(data => {
      setUserData(data.data);
      setFiltered(data?.data)
    }).catch(err => {
      console.log('userProfileGetErr', err);
    })
  }
  const getUserCountry = () => {
    axios.get('/countries/all').then(data => {
      console.log('datadata diqka', data)
      setCountryNames(data.data);

    }).catch(err => {
      console.log('userProfileGetErr', err);
    })
  }


  useEffect(() => {
    getUserData();
    getUserCountry();
  }, []);

  const handleModalAdd = () => {
    setModalType('add')
    setIsOpen(true);
  };

  const handleModalEdit = (data) => {
    setCityID(data)
    setModalType('edit')
    setIsOpen(true);
  };

  const handleMenuClick = (e) => {
    e.prevenTableHeadStyleefault();
    props.toggleMenu();
  };

  return (
    <>
      {isOpen === true ?
        <CitiesModal countryName={countryNames} city={CityID} isOpen={isOpen} type={modalType} getData={() => getUserData()} handleModalClose={() => {setIsOpen();setCityID(null)}} />
        : ""
      }
      <PageStyle isMenuOpen={props?.menu}>
        <PageTitleStyle>Cities</PageTitleStyle>
        {/* <Search /> */}
        <Search data={userData} filtered={setFiltered} setPageNumber={setPageNumber} />
        <MenuButton onClick={handleMenuClick}>{props.menu ? <i className="fa fa-chevron-left"></i> : <i className="fa fa-bars"></i>}</MenuButton>
        <PageContainer>
          <TableResponsive isMenuOpen={props?.menu}>
            <Table>
              <TableHead>
                <TableRowHead>
                  <TableHeadStyle tableFirstElement>ID</TableHeadStyle>
                  <TableHeadStyle >Name</TableHeadStyle>
                  <TableHeadStyle >Country</TableHeadStyle>
                  {/* <TableHeadStyle>Institution</TableHeadStyle>
                      <TableHeadStyle>Institution</TableHeadStyle>
                    <TableHeadStyle>Type</TableHeadStyle> */}
                  <TableHeadStyle>Actions</TableHeadStyle>
                </TableRowHead>
              </TableHead>
              <TableBody>
              {filtered && filtered?.length === 0 && <div className='text-secondary text  m-3'><h6>Nuk ka të dhëna</h6></div>
              }
                {filtered && filtered?.length > 0 && <>
                  {filtered?.slice(pagesVisited, pagesVisited + productsPerPage)?.map((el, index) => {
                    return (
                      <>
                        <TableRowBody>
                          <TableBodyStyle tableFirstElement>{el?.id}</TableBodyStyle>
                          <TableBodyStyle >{el?.name}</TableBodyStyle>
                          <TableBodyStyle>{countryNames?.find(elem => elem?.id == el?.country_id)?.name || 'Country not found'}</TableBodyStyle>

                          {/* <TableBodyStyle>Institution</TableBodyStyle>
                      <TableBodyStyle>Institution</TableBodyStyle> */}
                          {/* <TableBodyStyle>Type </TableBodyStyle> */}
                          <TableBodyStyle><EyeIcon onClick={() => handleModalEdit(el)} /> </TableBodyStyle>
                        </TableRowBody>
                             </>
                             )
                           })}</>
                         }
              </TableBody>
            </Table>
            <Pagination>
              <div className="text-right">
                {((userData?.length >= productsPerPage) ?
                  <ReactPaginate
                    previousLabel={<i className='fa fa-angle-double-left' />}
                    nextLabel={<i className='fa fa-angle-double-right' />}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={"paginationBttns"}
                    previousLinkClassName={"previousBttn"}
                    nextLinkClassName={"nextBttn"}
                    disabledClassName={"paginationDisabled"}
                    activeClassName={"paginationActive"}
                  /> : ''
                )}
              </div>
            </Pagination>
          </TableResponsive>
        </PageContainer>
      </PageStyle>

      <MenuButton add onClick={() => { handleModalAdd(); }}>
        <i className="fa fa-plus" />
      </MenuButton>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    lang: state.data.lang,
    langData: state.data.langData,
    isLoading: state.data.isLoading,
    loggedIn: state.data.loggedIn,
    menu: state.data.menu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loggMeIN: () => dispatch(loggMeIN()),
    rmAuth: () => dispatch(rmAuth()),
    toggleMenu: () => dispatch(toggleMenu()),
    // loadingOff: () => dispatch(loadingOff()),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Cities);
